'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import { useEffect, useState } from 'react';

// Cache to store the geolocation data across components
let cachedGeolocation = null;
let isLoading = false;
let subscribers = [];

const fetchGeolocation = async () => {
    if (cachedGeolocation) {
        console.info('Using cached geolocation');
        return cachedGeolocation;
    }

    if (isLoading) {
        // If already loading, wait for the existing request
        return new Promise(resolve => {
            subscribers.push(resolve);
        });
    }

    isLoading = true;

    try {
        const response = await fetch(
            'https://d2k6913brarspg.cloudfront.net/geo'
        );

        const geolocationData = {
            viewerCountry: response.headers.get('cloudfront-viewer-country'),
            viewerCountryRegion: response.headers.get(
                'cloudfront-viewer-country-region'
            ),
            viewerCity: response.headers.get('cloudfront-viewer-city'),
            viewerLat: response.headers.get('cloudfront-viewer-latitude'),
            viewerLong: response.headers.get('cloudfront-viewer-longitude'),
        };

        cachedGeolocation = geolocationData;

        // Notify all waiting subscribers
        subscribers.forEach(resolve => resolve(geolocationData));
        subscribers = [];

        return geolocationData;
    } catch (error) {
        console.error('Failed to fetch geolocation:', error);

        // Notify subscribers of the error
        subscribers.forEach(resolve => resolve(null));
        subscribers = [];

        return null;
    } finally {
        isLoading = false;
    }
};

fetchGeolocation();

export const useGeolocation = () => {
    const [geolocation, setGeolocation] = useState(cachedGeolocation);
    const [loading, setLoading] = useState(!cachedGeolocation);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (cachedGeolocation) {
            setGeolocation(cachedGeolocation);
            setLoading(false);
            return;
        }

        const loadGeolocation = async () => {
            try {
                setLoading(true);
                setError(null);
                const data = await fetchGeolocation();
                console.info('Geolocation hook data:', data);
                setGeolocation(data);
            } catch (err) {
                setError(err);
                console.error('Geolocation hook error:', err);
            } finally {
                setLoading(false);
            }
        };

        loadGeolocation();
    }, []);

    return { geoLocation: geolocation, loading, error };
};

export default useGeolocation;
